import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { TDashboardResponse } from "./types";
import { setTokenAction } from "../auth/slice";

export const getDashboardData = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (
    {
      page = 1,
      per_page = 3,
    }: {
      page: number;
      per_page: number;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response: AxiosResponse<TDashboardResponse> = await axios.get(
        `/v1/dashboard`,
        {
          params: {
            page: page,
            per_page: per_page,
          },
        }
      );

      if (response.data?.data?.token) {
        await dispatch(setTokenAction(response.data.data.token));
      }
      return response.data?.data?.dashboard;
    } catch (err) {
      return rejectWithValue((err as any).response?.data || err);
    }
  }
);
